import { render } from "./AcSwitch.vue?vue&type=template&id=2746fe08&ts=true"
import script from "./AcSwitch.vue?vue&type=script&lang=ts"
export * from "./AcSwitch.vue?vue&type=script&lang=ts"

import "./AcSwitch.vue?vue&type=style&index=0&id=2746fe08&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__